import React from "react";
import Hero from "../../Components/Hero/Hero";

interface Props {}

function HomePage({}: Props) {
  return (
    <>
      <Hero />
    </>
  );
}

export default HomePage;
